import React from 'react';
import Card from '../../../../components/Card/Card';
import { Row, Col } from 'reactstrap'


export default ({ navItems, activeTab, switchTab }) => {
    return (
        <Row>
            {navItems.map(item => (
                <Col key={item.id} lg='3'>
                    <Card className={activeTab === item.id ? 'active' : ''} onClick={e => switchTab(item.id)} style={{ cursor: "pointer" }}>
                        {item.translate}
                    </Card>
                </Col>
            ))}
        </Row>
    )
}